import { createContext } from "react";

const footerMenuContext = createContext();

export default footerMenuContext;